import "reflect-metadata";
import {inject, injectable} from "inversify";
import {TicketRepository} from "@dropDesk/domain/repositories/ticket/ticket.repository";
import {BackupData} from "@dropDesk/domain/entities/ticket/backup/backup_data";

@injectable()
export class StartBackupTicketsUseCase {
    private _repository: TicketRepository;

    constructor(@inject(TicketRepository) repository: TicketRepository) {
        this._repository = repository;
    }

    public call(): Promise<BackupData> {
        return this._repository.startBackup();
    }
}

